<template>
	
	<div class = 'order_banner_box'>
		
		<div :class = "banner_bg">
			{{ch}}&nbsp;|&nbsp;{{en}}
		</div>
		<div class = "order_banner_more">
			
			查看更多>>
			
		</div>
		
	</div>
	
	
</template>

<script>
	
	export default{
		computed:{
			banner_bg(){
				
					return "banner_bg bg_linear_gradient_"+this.index
				
				
			}
		},
		props:{
			en:String,
			ch:String,
			index:Number
		},
		
		data(){
			
			return {
				

			}
			
		},
		methods:{
			
		}
		
		
		
		
	}
	
	
	
</script>

<style>
	.order_banner_more{
		
		
			height: 0.885vw;
			font-family: PingFangSC-Regular;
			font-size: 0.938vw;
			font-weight: normal;
			font-stretch: normal;
			position: relative;
			right: 2vw;
			letter-spacing: 0vw;
			color: #757575;
		
	}
	.order_banner_box{
		margin-top: 3.2vw;
			position: relative;
			left: 10.667vw;
			width: 78.7vw;
			height: 3.75vw;
			background-color: #ffffff;
			display: flex;
			align-items: center;
		justify-content: space-between;
		margin-bottom: 2.031vw;
		
	}
	.banner_bg{
		
			width: auto;
			height: 3.75vw;
			padding-left: 2vw;
			padding-right: 2vw;
			background-blend-mode: normal, 
				normal;
			border-radius: 0vw 1.875vw 1.875vw 0vw;
			font-family: PingFangSC-Medium;
			font-size: 1.354vw;
			font-weight: normal;
			font-stretch: normal;
			line-height: 3.75vw;
			letter-spacing: 0vw;
			color: #f5f5f5;
	}
	.bg_linear_gradient_0{
		background-image: linear-gradient(-70deg,
			#5d70c7 0%, 
			#364ea1 100%), 
		linear-gradient(
			#eff4f9, 
			#eff4f9);
	}
	.bg_linear_gradient_1{
		background-image: linear-gradient(-70deg, 
				#68a9b9 0%, 
				#3e7e8f 100%), 
			linear-gradient(
				#eff4f9, 
				#eff4f9);
	}
	.bg_linear_gradient_2{
		background-image: linear-gradient(-70deg, 
				#f07b5a 0%, 
				#d84f31 100%), 
			linear-gradient(
				#eff4f9, 
				#eff4f9);
	}
	.bg_linear_gradient_3{
		background-image: linear-gradient(-70deg, 
				#a479d1 0%, 
				#723ab3 100%), 
			linear-gradient(
				#eff4f9, 
				#eff4f9);
	}
	.bg_linear_gradient_4{
		background-image: linear-gradient(-70deg, 
				#ecac69 0%, 
				#d37e41 100%), 
			linear-gradient(
				#eff4f9, 
				#eff4f9);
	}
</style>
